<script setup lang="ts">
  import { computed } from 'vue';
  import type { ChatBgShapeConfig } from '@/models/chat';

  const props = defineProps({
    color1: {
      type: String,
      required: true
    },
    color2: {
      type: String,
      required: true
    },
    isChameleonMode: {
      type: Boolean,
      default: false
    }
  });

  const chameleonMode = computed(() => props.isChameleonMode);

  const shapeConfig: ChatBgShapeConfig = {
    initialStart: {
      top: 308.04,
      left: 1482.64,
      width: 392.226,
      height: 702.965,
      rotation: 39.837,
      duration: 2,
      repeat: 0,
      yoyo: false,
      ease: 'power1.inOut'
    },
    initialEnd: {
      top: 614.15,
      left: 685.01,
      width: 392.226,
      height: 702.965,
      rotation: -54.423,
      duration: 15,
      repeat: -1,
      yoyo: true,
      ease: 'power1.inOut'
    },
    chameleonStart: {
      top: 281.76,
      left: 1067.23,
      width: 384.24,
      height: 456.884,
      rotation: 22.266,
      duration: 2,
      repeat: 0,
      yoyo: false,
      ease: 'power1.inOut'
    },
    chameleonEnd: {
      top: 423.54,
      left: 1356.43,
      width: 189,
      height: 456.884,
      rotation: -20,
      duration: 15,
      repeat: -1,
      yoyo: true,
      ease: 'power1.inOut'
    }
  };

  const { svgRef } = useChatBgShape(chameleonMode, shapeConfig);
</script>

<template>
  <svg
    ref="svgRef"
    :class="['chat-bg-shape', 'chat-bg-shape--4', { chameleon: chameleonMode }]"
    :style="{ '--chat-bg-color-1': color1, '--chat-bg-color-2': color2 }"
    width="393"
    height="703"
    viewBox="0 0 393 703"
    xmlns="http://www.w3.org/2000/svg">
    <ellipse
      cx="196.751"
      cy="351.524"
      rx="196.113"
      ry="351.482"
      fill="url(#paint0_radial_7_6)" />
    <defs>
      <radialGradient
        id="paint0_radial_7_6"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-10.1299 431.152 -1299.7 -362.598 178.761 424.942)"
        gradientUnits="userSpaceOnUse">
        <stop
          class="color1"
          offset="0" />
        <stop
          class="color2"
          offset="1" />
      </radialGradient>
    </defs>
  </svg>
</template>
